import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import testimonials from "../../data/testimonials";
import TestimonialCard from "../common/TestimonialCard";
import SectionHeading from "../common/SectionHeading";
import "./TestimonialsSection.css";

export default function TestimonialsSection() {
  return (
    <section className="testimonials-section section">
      <div className="container">
        <SectionHeading eyebrow="Member Stories" title="What our" highlight="members say" align="center" />
        <Swiper
          modules={[Autoplay, Pagination, Navigation, A11y]}
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{ 768: { slidesPerView: 2 }, 1100: { slidesPerView: 3 } }}
          autoplay={{ delay: 4500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={{ clickable: true }}
          navigation
          a11y={{ prevSlideMessage: "Previous testimonial", nextSlideMessage: "Next testimonial" }}
          className="testimonials-swiper"
        >
          {testimonials.map((t) => (
            <SwiperSlide key={t.id}>
              <TestimonialCard testimonial={t} />
            </SwiperSlide>
          ))}
        </Swiper>
        <p className="testimonials-section__note">Sample testimonials shown until verified member reviews are provided.</p>
      </div>
    </section>
  );
}
